// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.file-upload__container {\r\n  background-color: #f7f7f7;\r\n  border-radius: 2px;\r\n  padding: 15px;\r\n  margin-bottom: 10px;\n}\n.file-upload__label {\r\n  font-size: 14px;\r\n  color: gray;\n}\n.action-icon {\r\n  padding: 0 !important;\r\n  margin: 0 !important;\n}\n.action-button {\r\n  margin: 0 5px;\n}\r\n", ""]);
// Exports
module.exports = exports;
